import React, { useContext, useEffect, useState, useRef } from "react";
import API from "../pages/Services/Baseservice";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import ClipLoader from "react-spinners/ClipLoader";
import { LanguageContext } from "../pages/languagecontext";
import CalendarIcon from "../assets/img/blog-images/.svg";
import SEO from "./SEO";

const News = () => {
  const { selectedLanguage } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [newslist, setNewsList] = useState([]);
  const [FromDate1, setFromDate1] = useState("");
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(6);
  const [expandedIndexes, setExpandedIndexes] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const home = () => {
    navigate("/");
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      if (search.trim() === "" && FromDate1.trim() === "") {
        List();
      } else {
        Search();
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [search, FromDate1, selectedLanguage.id]);

  const List = () => {
    setLoading(true);
    let req = {
      search: "",
      rowsPerPage: "",
      page: "",
      language_id: selectedLanguage.id,
    };

    API.post("webnews_list/webCondition", req).then((response) => {
      if (response.data.success === true) {
        setNewsList(response.data.data.data || []);
        setLoading(false);
      }
    });
  };

  const Search = () => {
    let req = {
      search: search,
      rowsPerPage: "",
      page: "",
      date: FromDate1,
      language_id: selectedLanguage.id,
    };

    API.post("webnews_list/webCondition", req).then((response) => {
      if (response.data.success === true) {
        const dataArray = response.data.data?.data || response.data.data || [];
        setNewsList(Array.isArray(dataArray) ? dataArray : []);
      }
    });
  };

  const visibleBlogs = Array.isArray(newslist)
    ? newslist.slice(0, visibleCount)
    : [];

  const FromDateFilter = (event) => {
    if (event._isAMomentObject == true) {
      const timenew = event.format("YYYY-MM-DD");
      setFromDate1(timenew);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace" || e.key === "Delete") {
      setFromDate1("");
    }
  };

  const handleReadMore = (item) => {
    navigate("/specialnews", { state: { id: item } });
  };

  const toggleExpand = (index) => {
    if (expandedIndexes.includes(index)) {
      setExpandedIndexes(expandedIndexes.filter((i) => i !== index));
    } else {
      setExpandedIndexes([...expandedIndexes, index]);
    }
  };

  const showingFrom = 1;
  const showingTo = Math.min(visibleCount, newslist.length);
  const totalEntries = newslist.length;

  return (
    <div style={{ overflowX: "hidden" }}>
      <SEO
                title="Spousal sponsorship consultant Canada | Express Entry consultant"
                description="Latest updates and expert insights from ASRA Immigration News on Canada visas, policies, and family reunification by a trusted Spousal sponsorship consultant Canada."
                canonical="https://asraimmigration.ca/news"
            />
      {loading ? (
        <div
          className="d-flex justify-content-center mt-5 align-items-center p-5"
          style={{ height: "100vh" }}
        >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <div className="container px-3">
          <section className="faq-hero container p-4 p-lg-5 rounded-5">
            <h1>{selectedLanguage.id === 1 ? "News" : "Nouvelles"}</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      home();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {selectedLanguage.id === 1 ? "Home" : "Accueil"}
                  </a>
                </li>
                <li className="breadcrumb-item active">
                  {selectedLanguage.id === 1 ? "News" : "Nouvelles"}
                </li>
              </ol>
            </nav>
          </section>

          <div className="container news-section">
            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-4 gap-3 w-100">
              <h2 className="news-heading m-0">
                {selectedLanguage.id === 1
                  ? "Latest News"
                  : "Dernières nouvelles"}
              </h2>

              <div className="d-flex flex-column flex-sm-row align-items-center gap-3">
                <div className="position-relative" style={{ width: "250px" }}>
                  <Datetime
                    inputProps={{
                      className:
                        "form-control date-input rounded-pill shadow-sm border-0",
                      placeholder: "YYYY-MM-DD",
                      value: FromDate1,
                      onKeyDown: handleKeyDown,
                    }}
                    timeFormat={false}
                    dateFormat="MM-DD-YYYY"
                    closeOnSelect={true}
                    onChange={FromDateFilter}
                  />
                </div>

                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control rounded-pill shadow-sm border-0 pe-5"
                    placeholder={
                      selectedLanguage.id === 1 ? "Search.." : "Rechercher"
                    }
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ height: "38px" }}
                  />
                  <i className="bi bi-search position-absolute search-inner-icon"></i>
                </div>
              </div>
            </div>

            <div className="row g-4">
              {visibleBlogs.length > 0 ? (
                visibleBlogs.map((item, index) => {
                  const descriptionText = item.news_description
                    ? item.news_description
                        .replace(/<[^>]*>/g, "")
                        .substring(0, 150) + "..."
                    : "";

                  return (
                    <div key={index} className="col-md-4 col-sm-12">
                      <div className="news-card">
                        <div className="d-flex align-items-center mb-2">
                          {item.icon_image ? (
                            <img
                              src={item.icon_image}
                              alt="icon"
                              className="news-icon me-2"
                              // style={{ width: '24px', height: '24px', borderRadius: '50%' }}
                            />
                          ) : (
                            <i className="news-icon bi bi-person-circle me-2"></i>
                          )}
                          <div className="news-category">
                            {item.category_name || "CATEGORY"}
                          </div>
                        </div>

                        <h4 className="mt-3 headline">{item.heading}</h4>

                        <div className=" d-flex align-items-center gap-2 news-date mt-2">
                          <img
                            src={CalendarIcon}
                            className="calendericon"
                            alt="Date"
                          />
                          {item.date || "2025-01-01"}
                        </div>

                        <p className="news-description mt-3">
                          {descriptionText}
                        </p>

                        <a
                          href="#"
                          className="read-more"
                          onClick={(e) => {
                            e.preventDefault();
                            handleReadMore(item);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {selectedLanguage.id === 1
                            ? "Read More"
                            : "Lire la suite"}
                        </a>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  className="col-12 d-flex justify-content-center align-items-center"
                  style={{ minHeight: "200px" }}
                >
                  <p className="text-danger nodatafound">
                    {selectedLanguage.id === 1
                      ? "No Data Found"
                      : "Aucune donnée trouvée"}
                  </p>
                </div>
              )}
            </div>

            <div className="pagination-wrapper  pb-5">
              <p className="entries-info">
                {selectedLanguage.id === 1
                  ? `Showing ${showingFrom} to ${showingTo} of ${totalEntries} entries`
                  : `Affichage de ${showingFrom} à ${showingTo} sur ${totalEntries} entrées`}
              </p>
            </div>
            {visibleCount < newslist.length && (
              <div className="text-center mb-3">
                <button
                  className="btn viewmorebtn"
                  onClick={() => setVisibleCount((prev) => prev + 6)}
                >
                  {selectedLanguage.id === 1 ? "View More" : "Voir plus"}
                </button>
              </div>
            )}
            <div className="btn-pair1 mb-3">
              <a
                className="nav-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/faq");
                }}
                style={{ cursor: "pointer" }}
              >
                <button className="btn btn-danger d-flex align-items-center justify-content-center">
                  <p className="p-0 m-0">
                    {selectedLanguage.id === 1 ? "FAQ'S" : "FAQ"}
                  </p>
                  <i className="bi bi-arrow-right-circle-fill ms-1 book-icon"></i>
                </button>
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default News;
